import { useRef } from 'react';
import { Outlet } from 'react-router-dom';
import Tabs from '../tabs/tabs';
import { SidepanelReadTypes } from './types';
import formatDate from '../../helpers/format-date';

import styles from './transaction.module.css';

export default function IncomingOutgoingTransactionSidepanelRead({
  tabs,
  parentRef,
  parentScroll = 0,
  warnings,
  setSubPanelVisible,
  setSelectedDocumentName,
  getTransactionDocument,
  sendMessage,
  deletedAt,
}: SidepanelReadTypes): React.JSX.Element {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  let transationTabs = [
    {
      name: 'General Info',
      path: tabs?.generalPath || '',
    },
    {
      name: 'Order',
      path: tabs?.orderPath || '',
    },
    {
      name: 'AML & KYC',
      path: tabs?.amlPath || '',
    },
    {
      name: 'Status log',
      path: tabs?.logPath || '',
    },
    {
      name: 'Change log',
      path: tabs?.changeLogPath || '',
    },
    {
      name: 'Documents',
      path: tabs?.documentsPath || '',
    },
    {
      name: 'Chats',
      path: tabs?.chatTab || '',
    },
    {
      name: 'Comments',
      path: tabs?.commentsPath || '',
    },
  ];

  if (warnings && warnings.length) {
    transationTabs = [
      {
        name: 'General Info',
        path: tabs?.generalPath || '',
      },
      {
        name: 'Order',
        path: tabs?.orderPath || '',
      },
      {
        name: 'AML & KYC',
        path: tabs?.amlPath || '',
      },
      {
        name: 'Status log',
        path: tabs?.logPath || '',
      },
      {
        name: 'Change log',
        path: tabs?.changeLogPath || '',
      },
      {
        name: 'Warnings',
        path: tabs?.warningPath || '',
      },
      {
        name: 'Documents',
        path: tabs?.documentsPath || '',
      },
      {
        name: 'Chats',
        path: tabs?.chatTab || '',
      },
      {
        name: 'Comments',
        path: tabs?.commentsPath || '',
      },
    ];
  }

  return (
    <>
      {deletedAt && (
        <div className={styles.deleted}>{`Transaction deleted ${formatDate(
          deletedAt,
          true,
        )}`}</div>
      )}
      <Tabs
        enableRouting
        isTransactionsTabs
        withSticky
        // eslint-disable-next-line react-hooks/refs
        withShadow={parentScroll > Number(scrollRef.current?.offsetTop) - 130}
        onRouterClick={() => {
          if (parentScroll >= Number(scrollRef.current?.offsetTop) - 130) {
            parentRef?.current?.scrollTo({
              top: Number(scrollRef.current?.offsetTop) - 130,
            });
          }
        }}
        moreButtonClassName={styles.transactionMoreButton}
        tabs={transationTabs}
      />
      <div ref={scrollRef}>
        <Outlet
          context={{
            setSelectedDocumentName,
            setSubPanelVisible,
            getTransactionDocument,
            sendMessage,
          }}
        />
      </div>
    </>
  );
}
